<template>
  <div
      v-if="isReady && isSignedIn"
      class="user">
    <img
        v-if="showImage"
        :src="user.imageUrl"
        :alt="user.name"
        @error="showImage = false">
    <div class="user-info">
      <span class="user-info-name">
        {{ user.name }}
      </span>
      <span class="user-info-email">
        {{ user.email }}
      </span>
    </div>
    <base-button
        text="Sign out"
        type="transparent"
        @click="$store.dispatch('googleDriveBackup/signOut')"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import BaseButton from '@/components/core/BaseButton.vue';

export default {
  name: 'GoogleUserBanner',
  components: {
    BaseButton,
  },
  computed: {
    ...mapState({
      isReady: state => state.googleDriveBackup.isReady,
      isSignedIn: state => state.googleDriveBackup.isSignedIn,
      user: state => state.googleDriveBackup.user,
    }),
  },
  data() {
    return {
      showImage: true,
    };
  },
  mounted() {
    this.showImage = true;
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.user {
  align-items: center;
  background: $light-background;
  border-radius: 0.5rem;
  display: flex;
  padding: 1.25rem;
  margin-bottom: 1.5rem;

  img {
    $size: 3rem;
    border-radius: 5rem;
    height: $size;
    width: $size;
  }

  &-info {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: center;
    margin-left: 1rem;

    &-name {
      font-size: 1.125rem;
    }

    &-email {
      color: $secondary-text;
      font-size: 0.875rem;
    }
  }
}
</style>
